import { Button, ContentEl } from "../../../styledComponents";
import {
  Card,
  HomeCardContainer,
  Name,
  Role,
  Warning,
} from "./styledComponents";

const HomeContent = () => {
  return (
    <ContentEl>
      <HomeCardContainer className="container">
        <Card>
          <section>
            <p>Hello, My name is</p>
            <Name>Harikrishna Alwala</Name>
            <Role>MERN Full-Stack Developer</Role>
            <p>
              With a focus on ReactJs<sup>*</sup> , along with expertise in
              Express.js, MongoDB, and Node.js, I specialize in developing dynamic
              and responsive applications that enhance user engagement.
            </p>
            <button class="btn btn-primary">
            <a
          href="https://drive.google.com/file/d/1gkWdLO5tOpZHWcNP85EatliRW9j_7Qrs/view?usp=sharing"
          
          >Download Resume <i class="fa-solid fa-download"></i
        ></a>
              </button>
          </section>
        </Card>
        <Warning>
          <sup>*</sup> - currently in the learning phase
        </Warning>
      </HomeCardContainer>
    </ContentEl>
  );
};

export default HomeContent;
